import {
  Box,
  ProgressIndicator,
  SystemIcon,
  Typography,
} from '@wishket/design-system';
import { twMerge } from 'tailwind-merge';

interface ProgressBarProps {
  value: number;
  total: number;
}

const stripeStyle =
  'bg-w-orange-100 [background-image:repeating-linear-gradient(120deg,theme(colors.w-orange.200)_0px,theme(colors.w-orange.200)_1px,transparent_1px,transparent_3px)]';

const ProgressBar = ({ value, total }: ProgressBarProps) => {
  const isNotStarted = value === 0;
  const organizedValue = value || 1;

  const progressValue = (organizedValue / total) * 100;

  return (
    <Box className="flex items-center gap-4">
      <ProgressIndicator
        value={progressValue}
        className="h-2"
        progressClassName={twMerge(
          'bg-w-orange-500 rounded-full',
          isNotStarted && stripeStyle
        )}
      />
      <Box className="flex items-center">
        <Typography variant="body2" className="font-medium text-w-orange-500">
          {value}
        </Typography>
        <SystemIcon name="small_slash" className="text-w-gray-600" />
        <Typography variant="body2" className="font-medium text-w-gray-600">
          {total}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProgressBar;
